import { API_GET_SEARCH } from "../Config";

let debounceTimeout;

const SearchDebouncing = (type, searchterm, setProductData, recipeType) => {
  clearTimeout(debounceTimeout);
  debounceTimeout = setTimeout(async () => {
    try {
      let res = await API_GET_SEARCH(type, searchterm, recipeType);
      console.log(res.r);
      setProductData(res.r);
    } catch (error) {
      console.log(error);
    }
  }, 200);
};  
export { SearchDebouncing };
